export const CURRENCY = "USD";
